'use client';

import { useSession } from 'next-auth/react';
import Link from 'next/link';

import { Button } from 'components/ui/button';

import { useSignOut } from 'hooks/auth';

export function LogoutButton() {
  const { status } = useSession();
  const { handleLogout, loadingLogout } = useSignOut();
  const loading = status === 'loading' || loadingLogout;

  return (
    <div className="flex space-x-4">
      <Link href="/">
        <Button variant="outline">Back</Button>
      </Link>
      <Button loading={loading} onClick={handleLogout}>
        Sign out
      </Button>
    </div>
  );
}
